module.exports = __webpack_public_path__ + "img/Img_Academico.5e345597.png";